import React from "react";
import DehazeIcon from "@material-ui/icons/Dehaze";
import styles from "./Navbar.module.css";

const ToggleButton = ({ handleToggle }) => {
  return (
    <DehazeIcon
      fontSize="large"
      style={{ marginLeft: "20px" }}
      onClick={handleToggle}
      className={styles.toggleIcon}
    />
  );
};

export default ToggleButton;
